export const getExpandedListItemsCount = (items) =>
  Object.values(items).reduce((count, value) => (value ? count + 1 : count), 0);
